export const translatedAnswers: Record<string, Record<string, string>> = {
    customertype_c: {
        Privatperson: 'consumer',
        Organisation: 'company',
    },
    mailop_c: {
        'B.J. Distribution': 'bjdistribution',
        'Bonway AB': 'bonway',
        'CityMail Sweden AB': 'citymail',
        //'Bring Mail Nordic AB': 'bring',
        DHL: 'dhl',
        DSV: 'dsv',
        'Early Bird': 'earlybird',
        'Georgsson Mail AB': 'georgsson',
        //'Hall Media Logistik AB': 'hallmedia',
        //'Kiruna Mail AB': 'kiruna',
        'Lysekils Lokalpost': 'lysekil',
        'Mail Company Sweden AB': 'mailcompany',
        'Mailworld Office AB': 'mailworld',
        'Mariestads Brev & Paketservice AB': 'mariestad',
        'Mediakonsult i Göteborg AB': 'mediakonsult',
        //'Neovici AB': 'neovici',

        'Erna Logistik AB': 'nwt',
        'Point Logistik Gota Media AB': 'point',
        'PostNord Sverige AB': 'postnord',
        'Postmästaren i Hälsingeland AB': 'postmaster',
        'PREMO Pressens Morgontjänst AB': 'pressens',
        //'Prolog KB': 'prolog',
        'SDR Svensk Direktreklam AB': 'sdr',
        'Sundvalls Citypost AB': 'sundsvall',
        'Svensk Hemleverans HB': 'svensk',
        'Svensk Hemleverans i Norr KB': 'svenskhemlev',
        //'Tidningstjänst AB': 'tidning',
        UPS: 'ups',
        'VTD Västsvensk Tidningsdistribution AB': 'westsvensk',
        Annan: 'other',
        'Vet ej': 'dontknow',
    },
}
export const specialMappedQuestions = new Set([])
